export const convertToKebabCase = (str) => str.toLowerCase().split(' ').join('-');